/* src/app/admin-dashboard/system-info/system-info-popup/system-info-popup.css */
.popup-header {
  background-color: var(--custom-color);
  color: white;
  height: 90px;
  width: "auto";
  font-size: 20px;
  padding: 30px;
}
::ng-deep .mat-mdc-dialog-container {
  padding-top: 0 !important;
  border-radius: 15px;
  margin-bottom: 10px !important;
}
::ng-deep product-edit-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
::ng-deep .mat-mdc-dialog-actions {
  margin-right: 5px !important;
  margin-left: 0 !important;
  margin-bottom: 2px !important;
}
.example-chip-list {
  width: 100%;
}
.config-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 15px;
  align-items: center;
}
.example-card {
  max-width: 400px;
}
.example-card-footer {
  padding: 16px;
}
mat-list-item {
  display: flex;
  align-items: center;
}
mat-list-item button {
  margin-left: auto;
}
.form-field {
  display: flex;
  flex-direction: column;
}
@media (min-width:629px) {
  .form-control::-webkit-input-placeholder {
    color: transparent;
  }
  .form-control:-moz-placeholder {
    color: transparent;
  }
  .form-control::-moz-placeholder {
    color: transparent;
  }
  .form-control :-ms-input-placeholder {
    color: transparent;
  }
}
@media (max-width:629px) {
  div.optionalstuff {
    display: none;
  }
}
/*# sourceMappingURL=system-info-popup.css.map */
